import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home.vue'
import sportsVenueInfo from '../pages/detailPage/sportsVenueInfo.vue'




Vue.use(Router)
const routes = [
  {
    path: '',
    redirect:'/home'
  },
  {
    path: '/home',
    name:'home',
    component: home,
  },
  // {
  //   path: '/pages/home',
  //   name:'home',
  //   component: () =>
  //     import('@/pages/home'),
  // },
  {
    path:'/sportsVenueInfo',
    name:'sportsVenueInfo',
    // component:sportsVenueInfo
    component: () =>
      import('@/pages/detailPage/sportsVenueInfo'),
  },
  {
    path:'/callMe',
    name:'callMe',
    component: () =>
      import('@/pages/detailPage/callMe'),
  },
  {
    path:'/newsNotice',
    name:'newsNotice',
    component: () =>
      import('@/pages/detailPage/newsNotice'),

  },
  {
    path:'/sportsVenue',
    name:'sportsVenue',
    component: () =>
      import('@/pages/detailPage/sportsVenue'),
  },
  {
    path:'/commonMessage',
    name:'commonMessage',
    component: () =>
      import('@/pages/detailPage/commonMessage'),
  },
  {
    path:'/newsDetails',
    name:'newsDetails',
    component: () =>
      import('@/pages/detailPage/newsDetails'),
  },
  {
    path:'/messageDetails',
    name:'messageDetails',
    component: () =>
      import('@/pages/detailPage/messageDetails'),
  },
  // 学校场地
  {
    path:'/schoolSite',
    name:'schoolSite',
    component: () =>
      import('@/pages/detailPage/schoolSite'),
  },
  // 智慧健身房
  {
    path:'/wisdomGym',
    name:'wisdomGym',
    component: () =>
      import('@/pages/detailPage/wisdomGym'),
  },
  // 免费场馆
  {
    path:'/freeVenue',
    name:'freeVenue',
    component: () =>
      import('@/pages/detailPage/freeVenue'),
  },
  // 指导员驿站
  {
    path:'/politicalPost',
    name:'politicalPost',
    component: () =>
      import('@/pages/detailPage/politicalPost'),
  },
  // 赛事活动
  {
    path:'/matchActivity',
    name:'matchActivity',
    component: () =>
      import('@/pages/detailPage/matchActivity'),
  },
  // 健身地图
  {
    path:'/fitnessMap',
    name:'fitnessMap',
    component: () =>
      import('@/pages/detailPage/fitnessMap'),
  },
  // {
  //   path:'/fitnessMapIndex',
  //   name:'fitnessMapIndex',
  //   component: () =>
  //     import('@/pages/detailPage/fitnessMap/index'),
  // },
  // 课程详情
  {
    path:'/classDetail',
    name:'classDetail',
    component: () =>
      import('@/pages/detailPage/classDetail'),
  },
  // 赛事活动详情
  {
    path:'/matchDetail',
    name:'matchDetail',
    component: () =>
      import('@/pages/detailPage/matchDetail'),
  },
  // 学校健身房详情
  {
    path:'/siteDetail',
    name:'siteDetail',
    component: () =>
      import('@/pages/detailPage/siteDetail'),
  },
  // 健身点详情
  {
    path:'/fitnessDetail',
    name:'fitnessDetail',
    component: () =>
      import('@/pages/detailPage/fitnessDetail'),
  },
  // 预约指导
  {
    path:'/makeGuide',
    name:'makeGuide',
    component: () =>
      import('@/pages/detailPage/makeGuide'),
  },
  // 预约须知
  {
    path:'/orderFlow',
    name:'orderFlow',
    component: () =>
      import('@/pages/detailPage/orderFlow'),
  },
]
const router=new Router({routes:routes, mode: 'hash'})
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   if (to.path === '/login') {
//     sessionStorage.removeItem('izOutCamera')
//   }
//   let user = sessionStorage.getItem('izOutCamera')
//   if (!user && to.path !== '/login') {
//     // 若本地token不存在,则任意路由跳转的时候,重定向至login 登陆页面
//     next({
//       path: '/login',
//       // query: { redirect:to.fullPath}  // 将刚刚要去的路由path（却无权限）作为参数，方便登录成功后直接跳转到该路由
//     })
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js